import {
  SUPPORTED_STT_LANGUAGE_CODES,
  SYSTEM_DEFAULT_STT_LANGUAGE,
} from '@/constants/sttLanguages'

export interface SttLanguageResolverInput {
  conversationOverride?: string | null
  personaSttLanguage?: string | null
  userSttLanguage?: string | null
}

/**
 * Resolve the effective STT language code via the cascade
 *   conversation override → persona → user → system default ('multi').
 *
 * Unsupported codes (legacy or stale stored values) are skipped; the
 * resolver falls through to the next candidate.
 */
export function resolveSttLanguage(input: SttLanguageResolverInput): string {
  const candidates = [
    input.conversationOverride,
    input.personaSttLanguage,
    input.userSttLanguage,
  ]
  for (const c of candidates) {
    if (c && SUPPORTED_STT_LANGUAGE_CODES.has(c)) return c
  }
  return SYSTEM_DEFAULT_STT_LANGUAGE
}
